import { setUserData } from "../store/slices/userSlice";
import { API_BASE_URL } from "./apiConfig";
import { logApiContext } from "../config/apiBaseUrl";

const API_URL = `${API_BASE_URL}/api/users`;
const logRequest = (action, url) =>
  logApiContext(`authService:${action}`, { url, API_URL });

export const login = async (username, password, dispatch) => {
  try {
    const url = `${API_URL}/login`;
    logRequest("login", url);
    const response = await fetch(`${API_URL}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ username, password }),
    });

    if (!response.ok) {
      console.error("Login request failed", {
        status: response.status,
        statusText: response.statusText,
        url,
      });
      throw new Error("Credenciales inválidas");
    }

    const data = await response.json();
    const userData = {
      token: data.token,
      type: data.type,
      userId: data.userId, // antes usabas data._id (incorrecto ahora)
      driverName: data.driverName || null,
      driverId: data.driverId || null,
      licenses: data.licenses || [], // ahora guardamos el array
    };

    localStorage.setItem("token", data.token);
    localStorage.setItem("userData", JSON.stringify(userData));

    // ⬇️ Guardar en Redux los datos completos
    dispatch(setUserData(userData));

    return data;
  } catch (error) {
    console.error("Error en el login:", error);
    throw error;
  }
};

export const register = async ({
  username,
  password,
  type,
  name,
  lastName,
  hireDate,
  revenuePercentage,
}) => {
  const url = `${API_URL}/register`;
  logRequest("register", url);
  const response = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      username,
      password,
      type,
      name,
      lastName,
      hireDate,
      revenuePercentage,
    }),
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || "Error en el registro");
  }
  return await response.text();
};

export const isAuthenticated = () => {
  return !!localStorage.getItem("token"); // Devuelve true si hay un token guardado
};

export const getStoredUserType = () => {
  try {
    const stored = localStorage.getItem("userData");
    if (!stored) return null;
    const parsed = JSON.parse(stored);
    return parsed.type || null;
  } catch (err) {
    console.warn("No se pudo leer el rol del usuario:", err);
    return null;
  }
};

export const createUser = async (userData) => {
  try {
    const url = `${API_URL}/createUser`;
    logRequest("createUser", url);
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // Authorization: `Bearer ${localStorage.getItem("token")}`, // Solo si está protegido
      },
      body: JSON.stringify(userData),
    });

    if (!response.ok) {
      const error = await response.text();
      console.error("❌ Error en createUser response", {
        status: response.status,
        statusText: response.statusText,
        url,
        body: error,
      });
      throw new Error(error || "Error al crear usuario");
    }

    return await response.text(); // o `.json()` si devuelves un objeto
  } catch (error) {
    console.error("❌ Error en createUser:", error);
    throw error;
  }
};

export const createDriverByBoss = async (driverData) => {
  const response = await fetch(`${API_URL}/createDriver`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      // El Boss debe estar autenticado y enviar su token
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(driverData),
  });

  if (!response.ok) {
    // Si viene texto plano de error
    const text = await response.text();
    throw new Error(text || "Error al crear conductor");
  }

  return await response.text(); // o .json() si devuelves JSON
};
